export const LOAD_GLOBAL_PARAMS_STARTED = "LOAD_GLOBAL_PARAMS_STARTED";
export const LOAD_GLOBAL_PARAMS_SUCCESS = "LOAD_GLOBAL_PARAMS_SUCCESS";
export const INVALIDATE_GLOBAL_PARAMS = "INVALIDATE_GLOBAL_PARAMS";
